<template>
  <el-header class="main-header" height="60px">
    <el-row type="flex" justify="space-between" align="middle" class="header-row">
      <!-- Logo 部分 -->
      <el-col :span="6" class="logo-container">
        <router-link to="/" class="logo-link">
          北京生物工程学会
        </router-link>
      </el-col>

      <!-- 导航菜单部分 -->
      <el-col :span="12" class="menu-container">
        <el-menu
            :default-active="$route.path"
            class="main-menu"
            mode="horizontal"
            background-color="#ffffff"
            text-color="#8B4513"
            active-text-color="#D2691E"
            router
        >
          <el-menu-item index="/">首页</el-menu-item>

          <el-submenu index="about">
            <template slot="title">关于学会</template>
            <el-menu-item index="/about/introduction">学会简介</el-menu-item>
            <el-menu-item index="/about/constitution">学会章程</el-menu-item>
            <el-menu-item index="/about/council">理事会</el-menu-item>
            <el-menu-item index="/about/organization">组织机构</el-menu-item>
            <el-menu-item index="/about/history">大事记</el-menu-item>
          </el-submenu>

          <el-menu-item index="/news">新闻公告</el-menu-item>
          <el-menu-item index="/resources">学术资源</el-menu-item>

          <el-submenu index="member-home">
            <template slot="title">会员之家</template>
            <el-menu-item index="/member-guidelines">会员权益</el-menu-item>
            <el-menu-item v-if="!user" index="/register">会员注册</el-menu-item>
            <el-menu-item v-if="user" index="/payment">会费支付</el-menu-item>
          </el-submenu>

          <el-menu-item index="/forum">在线论坛</el-menu-item>
        </el-menu>
      </el-col>

      <!-- 用户状态部分 -->
      <el-col :span="6" class="user-status-container">
        <!-- 未登录状态 -->
        <div v-if="!user" class="user-actions">
          <el-button type="text" @click="handleLogin">登录</el-button>
          <el-button type="text" @click="handleRegister">注册</el-button>
        </div>

        <!-- 已登录状态 -->
        <div v-else class="user-info">
          <el-dropdown trigger="hover" @command="handleCommand">
            <span class="el-dropdown-link">
              <el-avatar :size="30" :src="user.avatar || defaultAvatar"></el-avatar>
              <span class="user-name">{{ user.username }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">个人中心</el-dropdown-item>
              <el-dropdown-item command="payment">会费支付</el-dropdown-item>
              <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-col>
    </el-row>
  </el-header>
</template>

<script>
import defaultAvatar from '@/assets/avatars/avatar5.svg'

export default {
  name: 'Header',
  data() {
    return {
      defaultAvatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
      user: (() => {
        const userInfo = localStorage.getItem('userInfo');
        if (userInfo && userInfo !== 'undefined' && userInfo !== 'null') {
          try {
            const user = JSON.parse(userInfo);
            // 如果用户没有头像，设置默认头像
            if (!user.avatar && !user.avatarUrl) {
              user.avatar = 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif';
              localStorage.setItem('userInfo', JSON.stringify(user));
            } else if (user.avatarUrl && !user.avatar) {
              // 将后端的avatarUrl字段映射到前端的avatar字段
              user.avatar = user.avatarUrl;
              localStorage.setItem('userInfo', JSON.stringify(user));
            }
            return user;
          } catch (error) {
            console.error('初始化时解析用户信息失败:', error);
            localStorage.removeItem('userInfo');
            return null;
          }
        }
        return null;
      })(),
    };
  },
  methods: {
    handleLogin() {
      if (this.$route.path !== '/login') {
        this.$router.push('/login');
      }
    },
    handleRegister() {
      if (this.$route.path !== '/register') {
        this.$router.push('/register');
      }
    },
    handleCommand(command) {
    if (command === 'logout') {
        this.logout();
    } else if (command === 'profile' && this.$route.path !== '/profile') {
        this.$router.push('/profile');
    } else if (command === 'payment' && this.$route.path !== '/payment') {
        this.$router.push('/payment');
    }
  },
    logout() {
      localStorage.removeItem('userInfo');
      localStorage.removeItem('userToken');
      this.user = null;
      this.$message.success('退出成功!');
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
    },
  },
  created() {
    // 2025-01-27: 修改头像更新事件监听逻辑
    this.$bus.$on('avatar-updated', (newAvatar) => {
      if (newAvatar) {
        this.user.avatar = newAvatar;
        localStorage.setItem('userInfo', JSON.stringify(this.user));
        this.$forceUpdate();
      }
    });
  },

  mounted() {
    // 2025-01-27: 修改登录成功事件监听逻辑
    if (this.$bus) {
      this.$bus.$on('login-success', () => {
        const userInfo = localStorage.getItem('userInfo');
        if (userInfo && userInfo !== 'undefined' && userInfo !== 'null') {
          try {
            this.user = JSON.parse(userInfo);
          } catch (error) {
            console.error('解析用户信息失败:', error);
            localStorage.removeItem('userInfo');
            this.user = null;
          }
        } else {
          this.user = null;
        }
      });
    }
  },

};
</script>

<style scoped>
/* 确保整个Header容器应用背景色 */
.main-header {
  background-color: #ffffff;
  color: #8B4513;
  padding: 0 20px;
  border-bottom: 1px solid #f0f0f0; /* 添加淡色边框 */
  width: 100%;
  position: relative; /* 确保Header在粒子特效上层 */
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.header-row {
  height: 100%;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.logo-link {
  font-size: 20px;
  font-weight: bold;
  color: #8B4513;
  text-decoration: none;
}

.menu-container {
  display: flex;
  justify-content: center;
}

/* 移除el-menu自带的下边框 */
.main-menu.el-menu--horizontal {
  border-bottom: none;
}

/* 确保子菜单背景色与主菜单一致 */
.el-menu--horizontal .el-submenu .el-menu-item,
.el-menu--horizontal .el-submenu .el-submenu__title {
  background-color: #ffffff !important;
  color: #8B4513 !important;
}

.el-menu--horizontal .el-menu .el-menu-item:hover,
.el-menu--horizontal .el-menu .el-submenu__title:hover {
  background-color: #F5DEB3 !important;
  color: #8B4513 !important;
}

.user-status-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.user-actions .el-button--text {
  color: #8B4513;
  font-size: 14px;
  margin-left: 15px;
}

.user-actions .el-button--text:hover {
  color: #D2691E;
}

.user-info .el-dropdown-link {
  cursor: pointer;
  color: #8B4513;
  display: flex;
  align-items: center;
}

.user-info .user-name {
  margin-left: 10px;
}

.user-info .el-avatar {
  background-color: #F5DEB3;
  color: #8B4513;
}
</style>
